<template>
    <b-form @submit.prevent="send">
        <b-form-group id="email-input-group" :label="$t('message.yourMessage')" label-for="message-input">
            <b-form-input
                id="message-input"
                v-model="message"
                v-validate="'required'"
                :placeholder="$t('message.onlyRepresentative')"
                autocomplete="off"
                autofocus
                name="message"
                trim
            />
            <span class="text-danger mt-3">{{ errors.first("message") }}</span>
        </b-form-group>

        <b-button class="primary rounded-0" type="submit">
            {{ $t("message.send") }}
        </b-button>
    </b-form>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { sendSocketMessage } from "../utils/socketStream";

export default {
    name: "PrivateMessage",
    data() {
        return {
            message: "",
        };
    },
    computed: mapState({
        user: (state) => state.auth.user,
        privateMessageConversation: (state) => state.chat.privateMessageConversation,
        site: (state) => state.site.site,
    }),
    methods: {
        ...mapActions({
            setPrivateMessageConversation: "chat/setPrivateMessageConversation",
        }),
        send() {
            this.$validator.validateAll().then((response) => {
                if (response) {
                    sendSocketMessage("user private-message", {
                        userId: this.user._id,
                        username: this.user.name,
                        conversationId: this.privateMessageConversation,
                        message: this.message,
                        siteId: this.site._id,
                    });

                    this.message = "";
                    this.$validator.reset();
                    this.setPrivateMessageConversation(null);
                }
            });
        },
    },
};
</script>

<style scoped></style>
